import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { buildRouteHead } from "@/lib/route-head";
import { faqSchema } from "@/lib/schema";
import { homeFaqItems } from "@/data/homeFaq";

// Organization-, LocalBusiness- und WebSite-Schema kommen sitewide aus __root.tsx —
// hier zusätzlich das FAQ-Schema für die Startseite.
export const Route = createFileRoute("/")({
  head: () => ({
    ...buildRouteHead({
      title: "Enno & Jens | Webdesign Wernigerode – SEO Webseiten",
      description:
        "Webdesign & SEO für Ärzte, Hotels, Handwerker und regionale Unternehmen. Wir erstellen moderne, suchmaschinenoptimierte Webseiten aus Wernigerode.",
      path: "/",
      image: "/images/hero-bg-1280.webp",
      imageAlt: "Agentur Enno & Jens aus Wernigerode im Harz",
      imageWidth: 1280,
      imageHeight: 720,
    }),
    scripts: [faqSchema(homeFaqItems)],
  }),
  component: Index,
});

